//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import update                    from 'immutability-helper';
import { ConfigurationTypes }    from '@/store/actions/configuration';

const initialState = {
    maxUploadSizeInBytes: null,
};

const fetchConfigurationSucceeded = (action, state) => {
    return update(state, {
        maxUploadSizeInBytes: {
            $set: action.maxUploadSizeInBytes,
        },
    });
};

export default (state = initialState, action) => {
    switch (action.type) {
        // @formatter:off
        case ConfigurationTypes.FETCH_CONFIGURATION_SUCCEEDED: return fetchConfigurationSucceeded(action, state);
        // @formatter:on
    }

    return state;
};
